import { Sound } from '@/utils/constant';
import { createContext, PropsWithChildren } from 'react';
import useSound from 'use-sound';

type TSoundContext = {
  event: {
    playTap: () => void;
    playPaymentSuccess: () => void;
    playPaymentFail: () => void;
    playInsertCard: () => void;
    playRemoveCard: () => void;
    playPaymentSuccessAmex: () => void;
    playPaymentSuccessDiscover: () => void;
    playPaymentSuccessVisa: () => void;
    playPaymentSuccessMasterCard: () => void;
  };
};

export const SoundContext = createContext<TSoundContext>({
  event: {
    playTap: () => undefined,
    playPaymentSuccess: () => undefined,
    playPaymentFail: () => undefined,
    playInsertCard: () => undefined,
    playRemoveCard: () => undefined,
    playPaymentSuccessAmex: () => undefined,
    playPaymentSuccessDiscover: () => undefined,
    playPaymentSuccessVisa: () => undefined,
    playPaymentSuccessMasterCard: () => undefined,
  },
});

export default function SoundProvider({ children }: PropsWithChildren) {
  const [playOnTap] = useSound(Sound.TAP);
  const [playOnPaymentSuccess] = useSound(Sound.PAYMENT_SUCCESS);
  const [playOnPaymentFail] = useSound(Sound.PAYMENT_FAILED);
  const [playOnInsertCard] = useSound(Sound.INSERT_CARD);
  const [playRemoveCard] = useSound(Sound.REMOVE_CARD);
  const [playOnPaymentSuccessAmex] = useSound(Sound.PAYMENT_SUCCESS_AMEX);
  const [playOnPaymentSuccessDiscover] = useSound(
    Sound.PAYMENT_SUCCESS_DISCOVER,
  );
  const [playOnPaymentSuccessVisa] = useSound(Sound.PAYMENT_SUCCESS_VISA);
  const [playOnPaymentSuccessMasterCard] = useSound(
    Sound.PAYMENT_SUCCESS_MASTERCARD,
  );

  return (
    <SoundContext.Provider
      value={{
        event: {
          playTap: () => playOnTap(),
          playPaymentSuccess: () => playOnPaymentSuccess(),
          playPaymentFail: () => playOnPaymentFail(),
          playInsertCard: () => playOnInsertCard(),
          playRemoveCard: () => playRemoveCard(),
          playPaymentSuccessAmex: () => playOnPaymentSuccessAmex(),
          playPaymentSuccessDiscover: () => playOnPaymentSuccessDiscover(),
          playPaymentSuccessVisa: () => playOnPaymentSuccessVisa(),
          playPaymentSuccessMasterCard: () => playOnPaymentSuccessMasterCard(),
        },
      }}
    >
      {children}
    </SoundContext.Provider>
  );
}
